export default __webpack_public_path__ + "41d8f0514d56e8d29dfff407f72f2f6b.svg";